export default __webpack_public_path__ + "static/media/Furious 2017 -- Ink on Paper -- 5.5 x 8.5in.71ab44af.jpg";